// ═══════════════════════════════════════════════════════════════════
//  modules/sanctions/Sanctions.js
//  Module « Suivi des Sanctions ».
//
//  Consultable par tout le staff. Les actions apparaissent selon le
//  grade, et le backend les revérifie de toute façon : l'interface
//  cache, elle ne protège pas.
// ═══════════════════════════════════════════════════════════════════

import { useCallback, useEffect, useMemo, useState } from "react";
import { useIsMobile } from "../../socle/hooks";
import { THEME } from "../../socle/theme";
import { sanctionsApi } from "./api";
import { ComptesLies } from "./ComptesLies";
import { DossiersMulticompte } from "./DossiersMulticompte";
import { SanctionFiche } from "./SanctionFiche";
import { SanctionsListe } from "./SanctionsListe";
import { SanctionsStats } from "./SanctionsStats";

const ONGLETS = [
  { id: "liste", label: "Sanctions", icone: "📋" },
  { id: "stats", label: "Statistiques", icone: "📊" },
  { id: "dossiers", label: "Double compte", icone: "🔍" },
  { id: "lies", label: "Comptes liés", icone: "🔗" },
];

export function Sanctions({ token, user, onNavigate }) {
  const isMobile = useIsMobile();
  const api = useMemo(() => sanctionsApi(token), [token]);
  const [onglet, setOnglet] = useState("liste");
  const [bareme, setBareme] = useState(null);
  const [ficheId, setFicheId] = useState(null);
  const [erreur, setErreur] = useState(null);

  const chargerBareme = useCallback(async () => {
    try { setBareme(await api.bareme()); } catch (e) { setErreur(e.message); }
  }, [api]);
  useEffect(() => { chargerBareme(); }, [chargerBareme]);

  const monGrade = bareme ? bareme.mon_grade : 1;
  const estAdmin = monGrade >= 3;

  const ouvrirJoueur = (pseudo) => {
    // L'ERP joueurs est la vue « dossier d'un joueur » ; on y renvoie.
    if (onNavigate) onNavigate("erp", { pseudo });
  };

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
        <div>
          <div style={{ color: THEME.text, fontSize: 22, fontWeight: 800 }}>⚖️ Suivi des Sanctions</div>
          <div style={{ color: THEME.textMuted, fontSize: 13, marginTop: 2 }}>
            {bareme
              ? `Prescription ${bareme.prescription_jours} j · fenêtre IP ${bareme.fenetre_ip_jours} j · observation ${bareme.observation_jours} j`
              : "chargement du barème…"}
            {bareme && !bareme.detection_active && (
              <b style={{ color: THEME.amber }}> · détection double compte désactivée</b>
            )}
          </div>
        </div>
      </div>

      {erreur && (
        <div style={{ background: THEME.redDim, border: `1px solid ${THEME.red}`, color: THEME.red, borderRadius: 8, padding: 11, marginBottom: 14, fontSize: 13 }}>
          {erreur}
        </div>
      )}

      {!ficheId && (
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
          {ONGLETS.map((o) => {
            const actif = onglet === o.id;
            return (
              <button key={o.id} onClick={() => setOnglet(o.id)}
                style={{
                  background: actif ? THEME.accentDim : THEME.surface,
                  border: `1px solid ${actif ? THEME.accent : THEME.border}`,
                  color: actif ? "#9CC2FF" : THEME.textMuted,
                  borderRadius: 10, padding: isMobile ? "7px 12px" : "8px 15px",
                  fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit",
                }}>
                {o.icone} {o.label}
              </button>
            );
          })}
        </div>
      )}

      {ficheId ? (
        <SanctionFiche api={api} id={ficheId} bareme={bareme}
          onRetour={() => setFicheId(null)} onChange={() => {}} />
      ) : (
        <>
          {onglet === "liste" && (
            <SanctionsListe api={api} bareme={bareme} onOuvrir={setFicheId} onJoueur={ouvrirJoueur} />
          )}
          {onglet === "stats" && <SanctionsStats api={api} bareme={bareme} />}
          {onglet === "dossiers" && <DossiersMulticompte api={api} peutStatuer={estAdmin} />}
          {onglet === "lies" && <ComptesLies api={api} peutGerer={estAdmin} />}
        </>
      )}
    </div>
  );
}
